var map = {
	"./24-hours.svg": "dd12",
	"./analysis.svg": "f396",
	"./line-chart.svg": "e8d3",
	"./linkedin.svg": "11db",
	"./piggy-bank.svg": "2b85",
	"./puzzle.svg": "10ef",
	"./secure-shield.svg": "883c",
	"./speech-bubble.svg": "1dd4",
	"./youtube.svg": "400a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65a8";